module.exports = __webpack_public_path__ + "static/media/station05.f3719d2e.jpg";